import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../../components/ReactSelect';
import { bin2hex, data, dataMysql, extract, pontoVirgula } from '../../../util/util';
import { toast } from 'react-toastify';
import ItemChecklist from '../../../components/ItemChecklist';
import { FaSave } from 'react-icons/fa';
import '../../../css/financeiro-parcela-pagar.css';

export default function AlterarEventoChecklist({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const idUsuario = localStorage.getItem("idUsuario");
    const nomeUsuario = localStorage.getItem("nomeUsuario");
    const perfil = localStorage.getItem("perfil");
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [reload, setReload] = useState(1);
    const history = useHistory();

    const buscar = () => {
        api({
            method: "get",
            action: '/eventoChecklist/' + id,
            token: token,
        }).then(response => {
            var dadosRecebidos = response.data.data;
            setDados(dadosRecebidos);
        }).catch(err => {
            toast.error('Erro ao carregar dados: ' + err.response.data.error);
        });
    };

    const validar = () => {
        /*
        var tipo = document.querySelector("#tipo");
        if (dados.tipo === undefined || dados.tipo === '') {
            toast.error('É necessário preencher o tipo da carta');
            setTimeout(() => {
                tipo.focus();
            }, 500);
            return false;
        }
        */
        return true;
    };

    const salvar = () => {
        if (!validar()) {
            return false;
        }

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        api({
            method: 'put',
            action: '/eventoChecklist/' + id,
            token: token,
            data: {
                ...dados,
            }
        })
            .then(function (response) {
                toast.success("Dados salvos com sucesso!");
                if (dados.evento?.id) {
                    history.push("/checklist?idEvento=" + dados.evento.id);
                } else {
                    history.push("/checklist");
                }
            })
            .catch(function (error) {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => {
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Checklist - {dados.evento?.nome ?? ""} - {data(dados.evento?.data)}</h1>
                        <div style={{ fontSize: 14, color: 'var(--fin-muted, #666)', marginTop: 2 }}>{dados.evento?.cliente?.nome ?? ""}</div>
                    </div>
                </div>
                <form onSubmit={e => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                            <h2 className="fin-pp__cphead-title">Atividades</h2>
                        </div>
                        <ItemChecklist dados={dados} stateChanger={setReload} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
